import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { view } from '@risingstack/react-easy-state'
import { EyeOutlined } from '@ant-design/icons'
import { message, Button, Pagination, Table, Input } from 'antd'

import StyledBox from 'components/common/styled-components/StyledBox'
import { staleWhileRevalidate } from 'utils/render-strategies'

import globalStore from 'store/index'
import APiLogsService from 'services/users/api-logs.service'

const APILogsIndexPage = () => {
	const history = useHistory()
	const pageState = globalStore.ui.apiLogs.index
	const [apiLogs, setApiLogs] = useState(null)
	const [searchValue, setSearchValue] = useState(null)
	const [currentPageSize, setCurrentPageSize] = useState(25)

	const [tableDataLoading, setTableDataLoading] = useState(false)

	useEffect(() => {
		const fetchData = async () => {
			const pageState = globalStore.ui.apiLogs.index
			setTableDataLoading(true)
			await APiLogsService.index({ pageState })
			setTableDataLoading(false)
			const { api_logs } = pageState
			if (api_logs) {
				setApiLogs(api_logs)
				return
			}

			message.error('Failed to load apiLogs')
		}

		fetchData()
	}, [])

	const {
		api_logsMeta,
		// displayType = "table",
	} = pageState

	const handleSearch = async (value) => {
		setSearchValue(value)

		const tempState = {}

		setTableDataLoading(true)
		await APiLogsService.index({ pageState: tempState, search: value })
		setTableDataLoading(false)

		const { api_logs, api_logsMeta } = tempState

		if (api_logs) {
			setApiLogs(api_logs)
			pageState.api_logsMeta = api_logsMeta
			return
		}
	}

	const repaginate = async (page, pageSize) => {
		const tempState = {}

		setTableDataLoading(true)

		await APiLogsService.index({ pageState: tempState, page, pageSize: pageSize || currentPageSize, search: searchValue })

		setTableDataLoading(false)

		const { api_logs, api_logsMeta } = tempState

		if (api_logs) {
			setApiLogs(api_logs)
			pageState.api_logsMeta = api_logsMeta
			return
		}
	}

	const handlePageSizeChange = (page, pageSize) => {
		setCurrentPageSize(pageSize)
		repaginate(1, pageSize)
	}

	const { total, page: currentPage } = api_logsMeta || {}

	const pagination = (
		<Pagination
			current={currentPage}
			total={total}
			onChange={repaginate}
			onShowSizeChange={handlePageSizeChange}
			pageSize={currentPageSize}
			pageSizeOptions={[10, 25, 50, 100]}
		/>
	)

	const handleFitmentClick = (apiLogsId) => {
		if (!apiLogsId) return null
		history.push(`/api-log/${apiLogsId}`)
	}

	const renderApiLogs = () => {
		const columns = [
			{
				title: 'Name',
				dataIndex: 'api_service_name',
				key: 'api_service_name',
			},
			{
				title: 'Log Type',
				dataIndex: 'loggable_type',
				key: 'loggable_type',
			},
			{
				title: 'Status',
				dataIndex: 'status',
				key: 'status',
			},
			{
				title: 'Action',
				dataIndex: 'action',
				key: 'action',
				align: 'right',
				render: (action, row) => {
					return (
						<div className='icon-box'>
							<Button type='link' onClick={() => handleFitmentClick(row.id)}>
								<EyeOutlined />
							</Button>
						</div>
					)
				},
			},
		]
		return (
			<div style={{ margin: '10px 0px' }}>
				<Table
					columns={columns}
					dataSource={apiLogs}
					loading={tableDataLoading}
					pagination={false}
				/>
			</div>
		)
	}

	const renderPageContent = () => {
		return (
			<div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}>
					<div
						className='action-buttons top'
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
							marginBottom: '20px',
					}}>
					<Input.Search
						placeholder='Email/Name/Emp ID'
						value={searchValue}
						onSearch={handleSearch}
						onChange={(e) => setSearchValue(e.target.value)}
					/>
				</div>
				</div>

				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: 10,
					}}>
					{pagination}
				</div>
				{renderApiLogs()}
				{pagination}
			</div>
		)
	}

	const { API_USERS_API_LOGS_INDEX_STATUS } = pageState

	return (
		<div className='page-content dashboard-page'>
			<StyledBox>
				{staleWhileRevalidate({
					status: API_USERS_API_LOGS_INDEX_STATUS,
					data: apiLogs,
					render: renderPageContent,
				})}
			</StyledBox>
		</div>
	)
}

export default view(APILogsIndexPage)
